var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "churn-form-component" }, [
    _c(
      "form",
      {
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.onSubmit.apply(null, arguments)
          },
        },
      },
      [
        _vm._l(_vm.sections, function (section) {
          return _c("div", { key: section.name, staticClass: "section my-3" }, [
            _c("h3", { staticClass: "subheading mt-2" }, [
              _vm._v("\n        " + _vm._s(section.title) + "\n      "),
            ]),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("VRating", {
                  ref: "ratings",
                  refInFor: true,
                  attrs: { hover: "" },
                  model: {
                    value: section.value,
                    callback: function ($$v) {
                      _vm.$set(section, "value", $$v)
                    },
                    expression: "section.value",
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "rating-reason" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.activeReason(section)) +
                      "\n        "
                  ),
                ]),
              ],
              1
            ),
          ])
        }),
        _vm._v(
          "\n    Do you have a specific example that comes in your mind? Something that can help up improve?\n    "
        ),
        _c("VTextField", {
          staticClass: "my-3 small base reason-text",
          attrs: { label: "Comment, suggestion…", small: "", solo: "" },
          model: {
            value: _vm.reasonText,
            callback: function ($$v) {
              _vm.reasonText = $$v
            },
            expression: "reasonText",
          },
        }),
        _vm._v(" "),
        _c(
          "VBtn",
          {
            staticClass: "button-next",
            attrs: {
              type: "submit",
              disabled: !_vm.isComplete,
              color: "primary",
            },
          },
          [_vm._v("\n      Next\n    ")]
        ),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }